import * as React from 'react';
import { ColorEnum } from '../../../enum/color.enum';
import styled from 'styled-components';
import {
  SMALL_SCREEN_SIZE,
  SOCIAL_BUTTON_LARGE_FONT_SIZE,
  SOCIAL_BUTTON_LARGE_ICON_SIZE,
  SOCIAL_BUTTON_SMALL_FONT_SIZE,
  SOCIAL_BUTTON_SMALL_ICON_SIZE
} from '../../../constants';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import Translate from '../../translate/translate';

interface IBaseSocialShareButtonWrapperProps {
  backgroundColor: string;
  width: number;
  height: number;
  padding: number;
}

const BaseSocialButtonWrapper = styled.div`
  width: ${(props: IBaseSocialShareButtonWrapperProps) => props.width}px;
  height: ${(props: IBaseSocialShareButtonWrapperProps) => props.height}px;
  background-color: ${(props: IBaseSocialShareButtonWrapperProps) => props.backgroundColor};
  border-radius: 4px;
  color: ${ColorEnum.White};
  display:flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  padding-left: ${(props: IBaseSocialShareButtonWrapperProps) => props.padding}px;
  padding-right: ${(props: IBaseSocialShareButtonWrapperProps) => props.padding}px;
`;

interface IBaseSocialButtonProps {
  icon: React.ReactNode;
  text: string;
  showButton: boolean;
  size?: 'large' | 'small';
  onClick: () => void;
  backgroundColor: string;
}

interface IBaseSocialButtonIconWrapperProps {
  iconWidth: number;
  iconHeight: number;
  color: string;
}

const BaseSocialButtonIconWrapper = styled.div`
  width: ${(props: IBaseSocialButtonIconWrapperProps) => props.iconWidth}px;
  height: ${(props: IBaseSocialButtonIconWrapperProps) => props.iconHeight}px;
  background-color: ${(props: IBaseSocialButtonIconWrapperProps) => ColorEnum.getColor(props.color)(props)};
  & svg {
    width: 100%;
    height: 100%;
  }
`;
export const BaseSocialShareButton = inject('state', 'dispatch')(observer((props: IBaseSocialButtonProps & IInjectedProps) => {
  if (!props.showButton) {
    return null;
  }
  let size = props.size;
  let iconHeight;
  let iconWidth;
  let fontSize;
  if (!size || props.state.configuration.isMobile || props.state.windowSize.width < SMALL_SCREEN_SIZE) {
    size = 'small';
  }
  if (size === 'large') {
    iconHeight = SOCIAL_BUTTON_LARGE_ICON_SIZE;
    fontSize = SOCIAL_BUTTON_LARGE_FONT_SIZE;
    iconWidth = SOCIAL_BUTTON_LARGE_ICON_SIZE;
  }
  if (size === 'small') {
    iconWidth = SOCIAL_BUTTON_SMALL_ICON_SIZE;
    iconHeight = SOCIAL_BUTTON_SMALL_ICON_SIZE;
    fontSize = SOCIAL_BUTTON_SMALL_FONT_SIZE;
  }

  return (
    <BaseSocialButtonWrapper
      onClick={props.onClick}
      height={35}
      width={size === 'large' ? 125 : 35}
      backgroundColor={props.backgroundColor}
      padding={size === 'large' ? 25 : 0}
    >
      <BaseSocialButtonIconWrapper
        iconWidth={iconWidth}
        iconHeight={iconHeight}
        color={props.state.colors.White}
      >
        {props.icon}
      </BaseSocialButtonIconWrapper>
      {size === 'large' ?
        <Translate style={{fontSize}}>{props.text}</Translate>
        : null
      }
    </BaseSocialButtonWrapper>
  );
}));
